export default {
  methods: {
    isActuallyRefundable(startDate, terms) {
      startDate = this.$moment(startDate);
      let notRefundableDate = startDate.subtract(terms + 1, 'days');

      return !this.$moment(notRefundableDate).isBefore(this.$moment());
    },
    refundableDateLimit(startDate, terms) {
      startDate = this.filters.start_date ? this.filters.start_date : startDate;
      startDate = this.$moment(startDate);
      let notRefundableDate = startDate.subtract(terms + 1, 'days');

      return notRefundableDate;
    },
    mealPlanColor(mealPlan) {
      if (this.$const('meal_plans', 'ROOM_ONLY') === mealPlan) {
        return 'is-warning';
      }

      return 'is-success'
    }
  }
}
